import "./CustomCheckbox.css";
import { Checkbox } from "@mui/material";
import React from "react";

export default function CustomCheckbox(props) {
  const { className = "" } = props;
  return <Checkbox className={`custom-checkbox ${className}`} {...props} />;
}
